import { nutritionFormAdapter } from "../form-adapter";
export const dairyNutritionAdapter = nutritionFormAdapter("dairy");
